// services/ApiService.ts
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { ApiResponse } from "../types/ApiResponse";
// import getEnvVars from '../../environment';
// import { apiUrl } from '../config';
import Constants from "expo-constants";
import AsyncStorage from "@react-native-async-storage/async-storage";
// const Constants = require("expo-constants");

const apiUrl = Constants.expoConfig?.extra?.API_URL;

interface ApiConfig extends AxiosRequestConfig {
  baseURL: string;
}

const apiConfig: ApiConfig = {
  baseURL: apiUrl,
  // timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
};

export const apiClient: AxiosInstance = axios.create(apiConfig);

// axiosRetry(apiClient, {
//   retries: 3,
//   retryDelay: (retryCount) => retryCount * 1000,
//   retryCondition: (error) => error.response?.status >= 500,
// });

// export function setAuthToken(token: string | null) {
//   if (token) {
//     apiClient.defaults.headers["Authorization"] = `Bearer ${token}`;
//   } else {
//     delete apiClient.defaults.headers["Authorization"];
//   }
// }

export async function setAuthToken() {
  const token = await AsyncStorage.getItem("userToken");
  console.log("here is token", token);

  if (token) {
    apiClient.defaults.headers["Authorization"] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers["Authorization"];
  }
}

// apiClient.interceptors.request.use(
//   (config) => {
//     // const token = 'your_token';
//     // if (token) {
//     //   config.headers['Authorization'] = `Bearer ${token}`;
//     // }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

apiClient.interceptors.response.use(
  async (config) => {
    const emulated = true;
    config.headers = {
      ...config.headers,
      isemulated: emulated ? "true" : "false", // Add the custom header
    };
    return config;
  },
  // (response: AxiosResponse) => response,
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => Promise.reject(error)
);

function handleError(error: any): ApiResponse {
  if (error.response) {
    console.error("API Error:", error.response);
    throw error.response;
  } else if (error.request) {
    console.error("Network Error:", error.request);
    throw error.request;
  } else {
    console.error("Error:", error.message);
    throw error;
  }
}

const addHeader = () => {
  apiClient.defaults.headers["isemulatd"] = "false";
};
export class ApiService {
  static async get<T>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<T>> {
    try {
      addHeader();
      const response = await apiClient.get(url, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async post<T>(
    url: string,
    data: any,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<T>> {
    try {
      const response = await apiClient.post(url, data, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async put<T>(
    url: string,
    data: any,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<T>> {
    try {
      addHeader();
      const response = await apiClient.put(url, data, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async delete<T>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<T>> {
    try {
      const response = await apiClient.delete(url, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
